import React from 'react';
import womanSchedulingImg from '../../../../../images/woman-scheduling.png';
import classNames from 'classnames';
import styles from './styles.module.scss';
import { Candidate } from '../../../../../entities/applicant_tracking/Candidate';
import { InterviewParticipants } from './InterviewParticipants';
import { VcsProvider } from '../../../../../enums/IntegrationProvider/VcsProvider';
import { InterviewerParticipant } from '../../../../../entities/applicant_tracking/InterviewerParticipant';
import { InterviewDuration } from './InterviewDuration';
import { InterviewMeetingProvider } from './InterviewMeetingProvider';
import { CalendarEventSelector } from './CalendarEventSelector';
import { EmailTemplate } from '../../../../../entities/EmailTemplate';
import { HorizontalDivider } from '../../../../../components/HorizontallDivider';
import { InterviewTemplate } from '../../../../../entities/v1/applicant_tracking/InterviewTemplate';
import { InterviewTemplateSelector } from './InterviewTemplateSelector';

interface PropTypes {
  title: string;
  applicationIds?: number[];
  candidate?: Candidate;
  totalApplications?: number;
  participants: InterviewerParticipant[];
  setParticipants: (participants: InterviewerParticipant[]) => void;
  durationMinutes: number;
  setDurationMinutes: (duration: number) => void;
  meetingProvider: VcsProvider;
  setMeetingProvider: (provider: VcsProvider) => void;
  meetingProviders: VcsProvider[];
  interviewTemplate: InterviewTemplate;
  setInterviewTemplate: (template: InterviewTemplate) => void;
  defaultInterviewTemplateId?: number | null;
  customImage?: string;
  description?: string;
  candidateView: boolean;
  emailTemplateId?: number;
  onChangingMeetingOrganizer: (participant: InterviewerParticipant) => void;
  allowChangingMeetingOrganizer: boolean;
  allowIgnoreParticipantCalendar: boolean;
  calendarEventTemplate: EmailTemplate;
  isEditingCalendarEventTemplate: boolean;
  setCalendarEventTemplate: (option: EmailTemplate) => void;
  setIsEditingCalendarEventTemplate: (isEditing: boolean) => void;
  personalizingSchedulingInvitesV1FfEnabled: boolean;
}

function Description(props: { description: string }) {
  if (props.description == null) {
    return null;
  }

  return (
    <div className={classNames('d-flex justify-content-center mb-3')}>
      <div
        className={classNames(
          'text-center fs-6 pt-1 text-muted',
          styles['description-text'],
        )}
      >
        {props.description}
      </div>
    </div>
  );
}

export function InterviewDetails(props: PropTypes) {
  const totalApplications =
    props.applicationIds?.length || props.totalApplications || 0;

  return (
    <>
      {(!props.personalizingSchedulingInvitesV1FfEnabled ||
        props.candidateView) && (
        <>
          <div className={'text-center'}>
            <img
              src={props.customImage || womanSchedulingImg}
              style={{ maxWidth: '250px' }}
            />
          </div>
          <h2 className={'mt-4 text-center'}>{props.title}</h2>
          <Description description={props.description} />
        </>
      )}
      <div className={classNames('d-flex', 'flex-column', styles['details'])}>
        {props.personalizingSchedulingInvitesV1FfEnabled &&
          !props.candidateView && (
            <InterviewTemplateSelector
              interviewTemplate={props.interviewTemplate}
              defaultInterviewTemplateId={props.defaultInterviewTemplateId}
              setInterviewTemplate={props.setInterviewTemplate}
            />
          )}
        <InterviewParticipants
          {...props}
          totalApplications={totalApplications}
        />
        <InterviewDuration
          durationMinutes={props.durationMinutes}
          candidateView={props.candidateView}
          setDurationMinutes={props.setDurationMinutes}
          className={'mt-4 w-60'}
        />
        <InterviewMeetingProvider
          meetingProvider={props.meetingProvider}
          setMeetingProvider={props.setMeetingProvider}
          candidateView={props.candidateView}
          meetingProviders={props.meetingProviders}
          className={'mt-3 w-60'}
        />
        {props.personalizingSchedulingInvitesV1FfEnabled &&
          !props.candidateView && (
            <>
              <HorizontalDivider classNames='my-3h' />
              <CalendarEventSelector
                allowEditingCalendarEventTemplate
                calendarEventTemplate={props.calendarEventTemplate}
                isEditingCalendarEventTemplate={
                  props.isEditingCalendarEventTemplate
                }
                emailTemplateId={props.emailTemplateId}
                setIsEditingCalendarEventTemplate={
                  props.setIsEditingCalendarEventTemplate
                }
                setCalendarEventTemplate={props.setCalendarEventTemplate}
              />
            </>
          )}
      </div>
    </>
  );
}
